import script from "./HTSnakeGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTSnakeGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTSnakeGamePlay.vue?vue&type=style&index=0&id=2ea95178&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea95178"]])

export default __exports__